import { decrypt } from "./local/functions/crypto";

export const isAuthenticated = () => {
  return !!localStorage.getItem("authToken");
};

export const isHost = () => {
  const user_type = localStorage.getItem("7653");
  if (user_type) {
    let user_role = decrypt(user_type);
    if (user_role == "host") {
      return true;
    }
  }
  return false;
};

export const isUser = () => {
  const user_type = localStorage.getItem("7653");
  if (user_type) {
    let user_role = decrypt(user_type);
    if (user_role == "user") {
      return true;
    }
  }
  return false;
};

export const is_influencer = () => {
  const Influencer = localStorage.getItem("345234");
  // console.log("Influencer1111111111 :", Influencer);
  if (Influencer) {
    let is_influencer = decrypt(Influencer);
    // console.log("is_influencer22222222222222 :", is_influencer);
    if (is_influencer == "true") {
      return true;
    }
  }
  return false;
};
